import { Pipe, PipeTransform } from '@angular/core';
import { WaybillIdType } from '../../store/constants/waybill.constant';
import { WaybillIdView } from '../../store/models/shipment-id-view.model';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'waybillHeaderTitle',
    standalone: false
})
export class WaybillHeaderTitlePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(identifier: WaybillIdView): string {
    const { hbl, mbl, waybillIdType } = identifier;
    const waybillIdentifier = Object.entries(identifier).reduce<string>(
      (acc: string, [key, value]: [string, string | WaybillIdType]) =>
        identifier.waybillIdType?.toLowerCase() === key && value ? `${value} (${key.toUpperCase()})` : acc,
      '',
    );
    const waybillTitle = `${this.translateService.instant('waybill.title')} ${waybillIdentifier}`;

    if (hbl && mbl && waybillIdType === WaybillIdType.HBL) {
      return `${waybillTitle}
        / ${mbl} (${this.translateService.instant('monitoring.transportManagement.houseAirWaybill.mbl')})`;
    }

    return `${waybillTitle}`;
  }
}
